import {Fill, Stroke, Style} from "ol/style";
import CircleStyle from "ol/style/Circle";
import {convertColor, hexToRgba} from "@/helpers/color-helper";
import {getGraphicName} from "@/helpers/ol/wfs/wfs-style-helper.js";
import {Icon} from "ol/style.js";

export function getDefaultStyleFunction() {
    return function (feature) {
            return getDefaultStyles()[feature.getGeometry().getType()];
    }
}

export function getDefaultSelectStyleFunction() {
    return function (feature) {
            return getDefaultStyles('select')[feature.getGeometry().getType()];
    }
}
export function getDefaultFilterStyleFunction() {
    return function (feature) {
            return getDefaultStyles('filter')[feature.getGeometry().getType()];
    }
}

export function getDefaultStyles(type = '') {

    const style = window.settings.wfsStyle

    let strokeColor = 'rgba(' + convertColor(style.strokeColor).rgbToString + ', ' + style.strokeOpacity + ')'
    let fillColor = 'rgba(' + convertColor(style.fillColor).rgbToString + ', ' + style.fillOpacity + ')'
    let strokeWidth = style.strokeWidth
    let radius = style.pointRadius

    if(type === 'select') {
        strokeColor = 'rgba(' + convertColor(style.SelectStrokeColor).rgbToString + ', ' + style.SelectStrokeOpacity + ')'
        fillColor = 'rgba(' + convertColor(style.SelectFillColor).rgbToString + ', ' + style.SelectFillOpacity + ')'
        strokeWidth = style.SelectStrokeWidth
        radius = style.SelectPointRadius
    }

    let image

    if(type === 'filter') {
        strokeColor = 'rgba(' + convertColor(style.FilterStrokeColor).rgbToString + ', ' + style.FilterStrokeOpacity + ')'
        fillColor = 'rgba(' + convertColor(style.FilterFillColor).rgbToString + ', ' + style.FilterFillOpacity + ')'
        strokeWidth = style.FilterStrokeWidth
        radius = style.FilterPointRadius


        if(style.FilterExternalGraphic) {

            image = new Icon({
                scale: style.FilterPointRadius / 10,
                opacity: 1,
                src: style.FilterExternalGraphic
            })
        }
    }

    if(!image) {
        image = new CircleStyle({
            radius: radius,
            fill: new Fill({
                color: fillColor
            }),
            stroke: new Stroke({color: strokeColor, width: strokeWidth}),
        });
    }




    return {
        'Point': new Style({
            image: image,
        }),
        'LineString': new Style({
            stroke: new Stroke({
                color: strokeColor,
                width: strokeWidth,
            }),
        }),
        'MultiLineString': new Style({
            stroke: new Stroke({
                color: strokeColor,
                width: strokeWidth,
            }),
        }),
        'MultiPoint': new Style({
            image: image,
        }),
        'MultiPolygon': new Style({
            stroke: new Stroke({
                color: strokeColor,
                width: strokeWidth,
            }),
            fill: new Fill({
                color: fillColor
            }),
        }),
        'Polygon': new Style({
            stroke: new Stroke({
                color: strokeColor,
                width: strokeWidth,
            }),
            fill: new Fill({
                color: fillColor
            }),
        }),
        'GeometryCollection': new Style({
            stroke: new Stroke({
                color: 'magenta',
                width: strokeWidth,
            }),
            fill: new Fill({
                color: 'magenta',
            }),
            image: new CircleStyle({
                radius: radius,
                fill: null,
                stroke: new Stroke({
                    color: strokeColor,
                }),
            }),
        }),
        'Circle': new Style({
            stroke: new Stroke({
                color: strokeColor,
                width: strokeWidth,
            }),
            fill: new Fill({
                color: fillColor
            }),
        }),
    };

}
